// Возвращает классы бейджа по типу периода (как в турнирах).
export function getTypeBadgeClasses(type) {
    switch (type) {
        case "daily":
            return "px-2 py-1 rounded-full text-xs whitespace-nowrap flex-shrink-0 bg-blue-100 text-blue-800";
        case "weekly":
            return "px-2 py-1 rounded-full text-xs whitespace-nowrap flex-shrink-0 bg-green-100 text-green-800";
        case "monthly":
            return "px-2 py-1 rounded-full text-xs whitespace-nowrap flex-shrink-0 bg-purple-100 text-purple-800";
        default:
            return "px-2 py-1 rounded-full text-xs whitespace-nowrap flex-shrink-0 bg-gray-100 text-gray-800";
    }
}
